const en = {
  error_title: 'An error has occurred',
  error_message: 'An error has occurred. Please reload the page or try again later.',
  error_reload_button: 'Reload Page',
  error_reload_hint: 'If the problem persists, please contact support.',

  not_found_title: 'Page Not Found',
  not_found_message: 'The page you are looking for does not exist or may have been moved.',
  not_found_back_button: 'Back to Home',

  validation_bad_request: 'The input contains errors. Please review and try again.',

  // Navigation
  nav_home: 'Home',
  nav_dashboard: 'Operations Summary',
  nav_group_dashboard: 'Dashboard',
  nav_group_applicant_import: 'Applicant Import',
  nav_group_mail_sms: 'Email & SMS',
  nav_use_media: 'Job Media Management',

  // Home page — information section
  home_loading: 'Loading…',
  home_information_title: 'Information',

  // Home page — startup section
  home_startup_title: 'Start Up',
  home_startup_all_chapter_title: 'ALL Chapter',
  home_startup_all_chapter_description: 'Set up SAISOKU from scratch',
  home_startup_chap1_title: 'Chapter 1',
  home_startup_chap1_description: 'Register job media',
  home_startup_chap2_title: 'Chapter 2',
  home_startup_chap2_description: 'Configure interview conditions',
  home_startup_chap3_title: 'Chapter 3',
  home_startup_chap3_description: 'Set up responses per applicant',
  home_startup_coming_soon: 'coming soon',

  // Use-media Create / Update
  use_media_create_title: 'Register New Job Media',
  use_media_update_title: 'Edit Job Media',
  use_media_account_alias_label: 'Setting Name',
  use_media_account_alias_placeholder: 'Enter setting name',
  use_media_account_alias_error: 'Setting name must be 64 characters or less.',
  use_media_duplicate_account_alias:
    'A record with the same media and setting name already exists. Please enter a different setting name.',
  use_media_media_label: 'Media',
  use_media_media_free_word_label: 'Search by keyword',
  use_media_media_list_label: 'Browse from list',
  use_media_media_placeholder: 'Search media by keyword',
  use_media_media_error: 'Please select a media.',
  use_media_media_type_error:
    'Media type information has not loaded yet. Please wait and try again.',
  use_media_login_confirm_button: 'Verify Login',
  use_media_login_confirm_error: 'Please verify login.',
  use_media_login_confirm_success: 'Login verified successfully.',
  use_media_login_confirm_failure: 'Login failed. Please check your credentials.',
  use_media_login_confirm_note1: '※ Multiple login failures may lock your account.',
  use_media_login_confirm_note2:
    '※ For security, please use the official login screen after a failure.',
  use_media_job_number_label: 'Job Number Acquisition Method',
  use_media_job_number_description_line_start:
    'The job number acquisition method varies by media. For details, please check ',
  use_media_job_number_help_link: 'Help Page',
  use_media_job_number_description_line_end: '.',
  use_media_job_number_csv_label: 'Use CSV/screen column',
  use_media_job_number_csv_branch_number_label: 'Use CSV/screen column (with branch number)',
  use_media_job_number_csv_column_label: 'Column',
  use_media_job_number_csv_column_error: 'Please select a column.',
  use_media_job_number_extract_label: 'Format',
  use_media_job_number_extract_error: 'Please select a format.',
  use_media_job_number_extract_branch_number_label: 'Branch number format',
  use_media_job_number_extract_branch_number_error: 'Please select a branch number format.',
  use_media_job_number_extract_branch_number_duplicate_error:
    'Format and branch number format must be different.',
  use_media_job_number_extract_branch_number_forbidden_combination_error:
    'This combination of formats cannot be selected. Please choose a different format.',
  use_media_job_number_media_extract_label: 'Use value extracted by media',
  use_media_job_number_media_extract_note: '※ Please contact Porters for configuration details.',
  use_media_job_number_fixed_label: 'Use a fixed job number',
  use_media_job_number_fixed_input_placeholder: 'Enter job number',
  use_media_job_number_fixed_error: 'Please enter the job number.',
  use_media_job_number_fixed_format_error: 'Job number must be a positive integer.',
  use_media_job_number_required_error: 'Please select a job number acquisition method.',
  use_media_register_channel_label: 'Count applications from this media in PORTERS',
  use_media_register_channel_use_label: 'Count',
  use_media_register_channel_not_use_label: 'Do not count',
  use_media_register_channel_select_label: 'Select the option to reflect in PORTERS',
  use_media_register_channel_required_error: 'Please select one.',
  use_media_register_channel_alias_error: 'Please select an option.',
  use_media_submit_button: 'Register',
  use_media_update_button: 'Update',
  use_media_copy_suffix: ' (copy)',
  use_media_back_to_list_button: 'Back to List',
  use_media_change_password_button: 'Change',
  use_media_show_password: 'Show password',
  use_media_hide_password: 'Hide password',
  use_media_create_success: 'Successfully registered',
  use_media_update_success: 'Successfully updated',
  use_media_login_field_required: 'Please enter {label}.',

  // Complete screen
  use_media_complete_create_title: 'Creation of media account "{accountAlias}" is complete',
  use_media_complete_update_title: 'Update of media account "{accountAlias}" is complete',
  use_media_complete_status_note:
    'After creation, the status is set to "Stopped". To start using it, change the status from the list screen.',
  use_media_complete_mail_note:
    'The application notification email address for this setting is shown below.\nPlease set this address as the notification destination in the media before starting use.\nYou can also copy the address from the media list.',
  use_media_complete_clipboard_alert: 'Application notification email address copied to clipboard',
  use_media_complete_clipboard_error:
    'Failed to copy application notification email address to clipboard. Please copy it manually.',
  use_media_complete_back_button: 'Back to Media List',
  use_media_complete_add_more_button: 'Add Another',

  // Extract rules
  extract_rule_1: 'Use as-is',
  extract_rule_2: 'Get number after / (half-width slash)',
  extract_rule_3: 'Get number before - (half-width hyphen)',
  extract_rule_5: 'Get number after - (half-width hyphen)',
  extract_rule_4: 'Get number after ／ (full-width slash)',
  extract_rule_6: 'Last 1 digit',
  extract_rule_7: 'Last 2 digits',
  extract_rule_8: 'Last 3 digits',

  // Use-media List
  use_media_list_title: 'Job Media Management',
  use_media_list_search_placeholder: 'Search by setting name or media name',
  use_media_list_filter_active_only: 'Show active only',
  use_media_list_create_button: 'Create New',
  use_media_list_col_account_alias: 'Setting Name',
  use_media_list_col_media: 'Media',
  use_media_list_col_status: 'Status',
  use_media_list_col_media_type: 'Import Method',
  use_media_list_col_mail_address: 'Notification Email',
  use_media_list_col_edit: 'Edit',
  use_media_list_col_copy: 'Copy',
  use_media_list_col_delete: 'Delete',
  use_media_list_status_inactive: 'Stopped',
  use_media_list_status_active: 'Active',
  use_media_list_status_test_mode: 'Test Mode',
  use_media_type_beautiful_soupe: 'Real-time',
  use_media_type_email: 'Email Import',
  use_media_type_beautiful_soupe_periodic: 'Scheduled',
  use_media_type_unknown: 'Unknown',
  use_media_list_pagination_info: '{start}-{end} / {total} items',
  use_media_list_no_data: 'No media accounts registered.',

  // Use-media List — Status change dialogs
  use_media_status_to_inactive_title: 'Disable media account',
  use_media_status_to_inactive_button: 'Stop',
  use_media_status_to_active_title: 'Enable media account',
  use_media_status_to_active_checklist_heading: 'Regarding data import',
  use_media_status_to_active_button: 'Activate',
  use_media_status_to_test_mode_title: 'Switching to test mode',
  use_media_status_to_test_mode_button: 'Change',
  use_media_status_test_mode_after_message:
    "Please submit job applications using the test email address. If, after submission, you notice that the application is not registered in Porters, or you are not receiving notifications, please verify the applicant's email address.",
  use_media_status_cancel_button: 'Cancel',
  use_media_status_close_button: 'Close',
  use_media_status_success_inactive: '"{accountAlias}" has been stopped.',
  use_media_status_success_active: '"{accountAlias}" is now active.',
  use_media_status_success_test_mode: 'Test mode enabled',
  use_media_status_dropdown_start: 'Start',
  use_media_status_dropdown_stop: 'Stop',
  use_media_status_dropdown_test_mode: 'Test Mode',
  use_media_status_test_domain_empty: 'No test application domains configured',
  use_media_status_test_address_empty: 'No test application email addresses configured',

  // Use-media List — Delete dialogs
  use_media_delete_confirm_title: 'Delete "{accountAlias}"?',
  use_media_delete_confirm_button: 'Delete',
  use_media_delete_cancel_button: 'Cancel',
  use_media_delete_success: '"{accountAlias}" has been deleted.',
  use_media_delete_cannot_title: 'Cannot delete',
  use_media_delete_cannot_message: 'Please change the status to "Stopped" before deleting.',
  use_media_delete_cannot_close_button: 'Close',
  dialog_cancel_button: 'Cancel',
  dialog_close_button: 'Close',

  // Shared SearchBox component
  searchbox_search_placeholder: 'Filter by keyword',
  searchbox_no_results: 'No matching items',
  searchbox_select_placeholder: 'Select',
  use_media_list_items_per_page: 'per page',

  // Dashboard — Report
  dashboard_report_title: 'Operations Summary',
  dashboard_report_description:
    'Export an operations summary for a specified period as an Excel file',
  dashboard_report_downloading: 'Downloading...',
  dashboard_report_download_button: 'Download Excel',
  dashboard_report_date_range_placeholder: 'Select a date range',
  dashboard_report_no_data: 'No data found for the selected period.',
  dashboard_report_download_complete: 'Download complete.',
  dashboard_report_download_error: 'Download failed. Please try again.',
  dashboard_report_query_timeout_title: 'Report Generation Timed Out',
  dashboard_report_query_timeout_message:
    'Report generation took too long. Try narrowing your search criteria (e.g. a shorter date range) and try again.',
  dashboard_report_date_range_label: 'Aggregation Period',
  dashboard_report_date_range_max_days_error:
    'The start and end dates must be within {maxDays} days of each other.',
  dashboard_report_date_range_future_error: 'The end date cannot be in the future.',
  dashboard_report_date_range_order_error: 'The end date must be on or after the start date.',
  dashboard_report_basis_label: 'Basis',
  dashboard_report_basis_entry: 'Application Date',
  dashboard_report_basis_event: 'Event Date',

  // Navigation
  nav_template: 'Templates',

  // Template list page
  template_page_title: 'Templates',
  template_mail_tab: 'Mail ({mailType})',
  template_mail_company: 'Internal Notification',
  template_mail_applicant: 'Applicant Notification',
  template_tab_sms: 'SMS',
  template_create_button: 'New',

  // Template empty state
  template_no_items: 'No templates registered.',

  // Template form dialog — shared
  template_form_name_label: 'Template Name',
  template_form_tags_label: 'Tags',
  template_tag_1: 'Valid Application',
  template_tag_2: 'Form Sent',
  template_tag_3: 'Interview Setup Sent',
  template_form_name_placeholder: 'e.g. Application Received',
  template_form_subject_label: 'Subject',
  template_form_subject_placeholder: 'e.g. [SAISOKU] Thank you for applying',
  template_form_body_label: 'Body',
  template_form_body_placeholder_sms: 'e.g. Dear {{applicant.name}}, thank you for applying.',
  template_form_variable_insert_button: 'Insert Variable',
  template_form_save_button: 'Save',
  template_form_name_required_error: 'Please enter the template name.',
  template_form_name_max_error: 'Template name must be 64 characters or less.',
  template_form_subject_required_error: 'Please enter the subject.',
  template_form_subject_max_error: 'Subject must be 128 characters or less.',
  template_form_body_required_error: 'Please enter the body.',

  // Template duplicate error
  template_duplicate_name_error:
    'This template name is already in use. Please enter a different template name.',

  // Template clone name suffix
  template_clone_name_suffix: ' (Copy)',

  // Template form page — browser tab titles
  template_mail_create_title: 'New Template (Mail)',
  template_mail_update_title: 'Edit Template (Mail)',
  template_sms_create_title: 'New Template (SMS)',
  template_sms_update_title: 'Edit Template (SMS)',

  // Template form page — heading (mail templates show which mailTemplateType they belong to)
  template_mail_create_heading: 'New Mail Template ({mailTypeLabel})',
  template_mail_update_heading: 'Edit Mail Template ({mailTypeLabel})',

  // Template form page — back button and save success
  template_back_to_list_button: 'Back to List',
  template_save_success: 'Template saved.',

  // Tiptap editor toolbar
  template_form_editor_bold: 'Bold',
  template_form_editor_italic: 'Italic',
  template_form_editor_underline: 'Underline',
  template_form_editor_h1: 'Heading 1',
  template_form_editor_h2: 'Heading 2',
  template_form_editor_h3: 'Heading 3',
  template_form_editor_bullet_list: 'Bullet List',
  template_form_editor_ordered_list: 'Ordered List',
  template_form_editor_add_link: 'Add Link',
  template_form_editor_remove_link: 'Remove Link',
  template_form_editor_clear_formatting: 'Clear Formatting',
  template_form_editor_enter_url: 'Enter the URL',
  template_form_editor_link_dialog_title: 'Add Link',
  template_form_editor_link_dialog_label: 'URL',
  template_form_editor_link_dialog_placeholder: 'https://example.com',
  template_form_editor_link_dialog_confirm: 'Add',
  template_form_editor_link_dialog_invalid_url:
    'Enter a valid URL starting with http://, https://, mailto:, or a relative path.',

  // Template delete dialog
  template_delete_confirm_message: 'Are you sure you want to delete this template?',
  template_delete_confirm_button: 'Delete',
  template_delete_error: 'Failed to delete the template. Please try again later.',
  template_delete_in_use_title: 'Cannot delete',
  template_delete_in_use_message:
    'This template cannot be deleted because it is in use by the filtering condition(s) [{names}].\nRemove this template from [{names}] (filtering conditions) before deleting it.',

  // Template list item
  template_item_id_label: 'ID:',
  template_item_created_at_label: 'Created:',
  template_item_edit_button: 'Edit',
  template_item_clone_button: 'Clone',
  template_item_delete_button: 'Delete',

  // SMS body character count
  template_sms_body_char_count: '{count} / 160 chars',

  // Variable placeholder labels
  template_var_form_url: 'Form URL',
  template_var_form_url_file: 'File Upload URL',
  template_var_zloss_url: 'Interview URL',
  template_var_applicant_name: 'Applicant Name',
  template_var_applicant_job_number: 'Job Number',
  template_var_applicant_job_title: 'Job Title',
  template_var_resume_id: 'Resume ID',
  template_var_resume_url: 'Resume URL',
  template_var_system_account_name: 'Entry Route (Detail)',
} as const;

export default en;
